/* istanbul ignore file */
import { boolean as codecBoolean, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutoTestGlobalSetupScriptParser = 
/* #__PURE__ */ parsers.object([
    ['userProvided', codecBoolean, 'user_provided'],
    ['cmd', codecString],
]);
export class AutoTestGlobalSetupScript extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestGlobalSetupScriptParser.decode(input).map(res => new AutoTestGlobalSetupScript(res));
    }
    static unsafeDecode(input) {
        return AutoTestGlobalSetupScript.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestGlobalSetupScriptParser.encode(data);
    }
    static schema() {
        return AutoTestGlobalSetupScriptParser.schema();
    }
}
